

export const FORECAST_FETCH  = 'FORECAST_FETCH'; //get the forecast data rows for table
export const FORECAST_UPDATE = 'FORECAST_UPDATE'; //get the forecast data rows for table
export const FORECAST_ERROR  = 'FORECAST_ERROR'; //get the forecast data rows for table
export const FORECAST_FILTER = 'FORECAST_FILTER'; //get the forecast data rows for table
export const FORECAST_TO_INDEX = 'FORECAST_TO_INDEX'; 
export const FORECAST_TO_LIST  = 'FORECAST_TO_LIST';    //LIST THE products with price list
export const FORECAST_LIST_UPDATE  = 'FORECAST_LIST_UPDATE';    //LIST THE products with price list
export const FORECAST_TO_REJECT = 'FORECASE_TO_REJECT'; //rejct with comment